import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";

const metricProcessName = "SCC_PACKAGE_SEARCH";
export async function getEntityFromInput(entityId, nodeId) {
    const requestBody = {
        "entityId": entityId,
        "nodeId": nodeId
    }
    const startTime = Date.now();

    const request = {
        resourcePath: "/os/getEntityFromInput",
        httpMethod: "post",
        processName: "oculus",
        requestBody: requestBody
    }

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {

            logOperationalMetric(startTime, metricProcessName, "getEntityFromInput", true);
            return response.data;
        } else {

            logOperationalMetric(startTime, metricProcessName, "getEntityFromInput", false);
            return null;
        }
    } catch (error) {
        return null;
    }

}

export function getMockEntityFromInputResponseForGMDPkg(entityId) {
    return {
        entityIds: { packageId: entityId, trackingId: entityId },
        type: "PACKAGE"
    }
}


// WEBPACK FOOTER //
// ./src/commons/api/GetEntityDetails.js